<template>
  <div class="col-12 col-xl-12" v-can="'areas.display'">
    <div class="card mb-3 mb-xxl-5 me-xxl-4" style="margin-top: 4rem; overflow: visible">
      <!-- Header -->
      <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2" style="height: 60px">
        <div class="bg-gradient-primary shadow-primary border-radius-lg pt-4 pb-3 h-100">
          <h6 class="text-white text-capitalize ps-3 pe-3" style="font-size: 1rem">
            {{ t('settings.areas.indexTitle') }}
          </h6>
        </div>
      </div>

      <div class="card-body px-0 pb-2 pe-xl-3">
        <div class="table-responsive p-1 p-xl-4">
          <!-- Loading -->
          <LoadingSpinner
            v-if="loading"
            :message="t('common.loading')"
            class="py-5"
          />

          <template v-else>
            <!-- Mobile cards -->
            <div class="d-block d-xl-none">
              <div v-if="items.length === 0" class="text-center py-3 text-muted">
                <i class="fas fa-map-marker-alt fa-2x mb-2"></i>
                <p>{{ t('common.noData') }}</p>
              </div>

              <div
                v-for="a in items"
                :key="'mob-' + a.id"
                class="card mb-3 mx-2"
              >
                <div class="card-body py-2">
                  <div class="d-flex justify-content-between align-items-start">
                    <h6 class="mb-0 text-sm">
                      {{ a.name }}
                    </h6>
                  </div>

                  <div class="d-flex justify-content-end mt-2">
                    <router-link
                      :to="{ name: 'settings.areas.edit', params: { id: a.id } }"
                      class="btn btn-link text-secondary p-0 mx-1"
                      :title="t('common.edit')"
                      v-can="'areas.update'"
                    >
                      <i class="fas fa-edit fa-xs"></i>
                    </router-link>
                    <button
                      class="btn btn-link text-danger p-0 mx-1"
                      :title="t('common.delete')"
                      @click="$emit('delete', a)"
                      v-can="'areas.delete'"
                    >
                      <i class="fas fa-trash fa-xs"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Desktop table -->
            <table class="table align-items-center mb-0 d-none d-xl-table">
              <thead>
                <tr>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7">
                    {{ t('settings.areas.fields.name') }}
                  </th>
                  <th class="text-uppercase text-xxs font-weight-bolder opacity-7 text-center pe-4">
                    {{ t('common.actions') }}
                  </th>
                </tr>
              </thead>

              <tbody>
                <tr v-if="items.length === 0">
                  <td colspan="2" class="text-center py-4 text-muted">
                    <i class="fas fa-map-marker-alt fa-2x mb-2"></i>
                    <p>{{ t('common.noData') }}</p>
                  </td>
                </tr>

                <tr v-for="a in items" :key="a.id">
                  <td class="text-md px-3 py-2">{{ a.name }}</td>

                  <td class="align-middle text-center pe-4">
                    <div class="d-inline-flex">
                      <router-link
                        :to="{ name: 'settings.areas.edit', params: { id: a.id } }"
                        class="btn btn-link text-secondary p-1 mx-1"
                        :title="t('common.edit')"
                        v-can="'areas.update'"
                      >
                        <i class="fas fa-edit fa-sm"></i>
                      </router-link>

                      <button
                        class="btn btn-link text-danger p-1 mx-1"
                        :title="t('common.delete')"
                        @click="$emit('delete', a)"
                        v-can="'areas.delete'"
                      >
                        <i class="fas fa-trash fa-sm"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
import { defineProps } from 'vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

defineProps({
  items: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
})
</script>
